import { Box, Stack } from "@mui/material";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";
import { GoGift } from "react-icons/go";

export function IconCircle() {
  const theme = useSSTheme();
  return (
    <Stack
      sx={{
        p: "2px",
        borderRadius: "50%",
        background: `linear-gradient(135deg, ${theme.mui.palette.primary.main}, rgba(0,0,0,0.35))`,
        boxShadow: "0 2px 2px rgba(0,0,0,0.08)",
        transition: "transform 180ms ease, box-shadow 180ms ease",
        "&:hover": {
          transform: "translateY(-1px)",
          boxShadow: "0 12px 28px rgba(0,0,0,0.10)",
        },
      }}
    >
      <Box
        sx={{
          width: "96px",
          height: "96px",
          borderRadius: "50%",
          backgroundColor: theme.mui.palette.background.paper,
          border: `1px solid ${theme.mui.palette.divider}`,
          display: "grid",
          placeItems: "center",
        }}
      >
        <GoGift size={40} color={theme.mui.palette.primary.main} />
      </Box>
    </Stack>
  );
}
